module.exports = __webpack_public_path__ + "img/fr_AnswerTurtle.419245b8.svg";